import { useContext } from 'react'
import { MethodsContext } from '../components/providers/Methods'

export const useMethods = () => useContext(MethodsContext)